export default "__VITE_ASSET__CRw8WA55__"